import { Alert } from '@designsforhealth/dfh-react-components'
import { Subscribe } from '@react-rxjs/core'
import React, { useEffect } from 'react'

import { useResultWithLeftEffect } from '../../../../../../hooks/useResultWithLeftEffect'
import { getDispensaryBasePath } from '../../../../../../lib/dispensaries'
import { useUserDispensary } from '../../../../../../lib/dispensaries/hooks/useUserDispensary'
import { useOnboardPatientClaim } from '../../../../../../lib/onboarding/hooks/useOnboardPatientClaim'
import {
  latestPatientSanityDispensary$,
  setPatientDispensaryFetchMethod,
  usePatientSanityDispensary,
} from '../../../../../../lib/sanity-dispensaries/patient-dispensary'
import { constNull } from '../../../../../../utils/constant'
import { pluckData } from '../../../../../../utils/result'
import { DispensaryContactCard } from '../../../../../dispensaries/contact-card/DispensaryContactCard'
import Spinner from '../../../../../Spinner'
import * as Styled from './styled'
import { FinishOnboardingLink } from './styled'

import graphicOrangeBlue from '../../../../../../img/color-waves-orange-blue.svg'

const PatientDispensaryContactContent: React.FC = () => {
  const [patientDispensaryResult, sanityDispensaryResult] = usePatientSanityDispensary()
  const { isOnboardingComplete } = useOnboardPatientClaim()
  const [patientDispensaryError, patientDispensary] = useResultWithLeftEffect(
    patientDispensaryResult,
    pluckData,
    constNull,
  )
  const [sanityDispensaryError, sanityDispensary] = useResultWithLeftEffect(
    sanityDispensaryResult,
    pluckData,
    constNull,
  )

  if (patientDispensaryError || sanityDispensaryError) {
    return (
      <Alert type="error">
        An error occurred while loading the dispensary information. Please refresh the page to try
        again.
      </Alert>
    )
  }
  if (!isOnboardingComplete && !patientDispensary) {
    return (
      <Alert type="informational">
        You have not yet selected a practitioner. Please{' '}
        <b>
          <FinishOnboardingLink to={'/onboarding'}>click here</FinishOnboardingLink>
        </b>{' '}
        to select one now.
      </Alert>
    )
  }
  if (!patientDispensary) {
    return (
      <Alert type="informational">
        Your practitioner doesn&apos;t have a dispensary yet. Please come back later.
      </Alert>
    )
  }
  return (
    <>
      <DispensaryContactCard
        dispensary={patientDispensary}
        contact={sanityDispensary?.contact}
        graphicSrc={graphicOrangeBlue}
        clickableLinks
      />
      <Styled.VisitDispensaryLink to={getDispensaryBasePath(patientDispensary.slug)} forceBase>
        Visit Dispensary
      </Styled.VisitDispensaryLink>
    </>
  )
}

const PatientDispensaryContact: React.FC = () => {
  const { getUserDispensary } = useUserDispensary()

  useEffect(() => {
    setPatientDispensaryFetchMethod(getUserDispensary)
  }, [getUserDispensary])

  return (
    <>
      <Styled.Title>Your Practitioner</Styled.Title>
      <Subscribe source$={latestPatientSanityDispensary$} fallback={<Spinner loading />}>
        <PatientDispensaryContactContent />
      </Subscribe>
    </>
  )
}

export default PatientDispensaryContact
